<div class="grid p-mobile-friendly animate-fade-in">
  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <h1 class="text-center text-2xl md:text-3xl font-bold animate-slide-up">Select Event</h1>
    <p class="text-center text-color-secondary mb-4">Choose an event to manage check-ins</p>
  </div>

  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <div class="grid gap-3">
      @for (eventMenuItem of eventMenuItemList; track eventMenuItem; let i = $index) {
        <div class="col-12 animate-slide-up" [style.animation-delay]="i * 0.1 + 's'">
          <a
            (click)="onSelectEvent(eventMenuItem.id)"
            (keyup.enter)="onSelectEvent(eventMenuItem.id)"
            (keyup.space)="onSelectEvent(eventMenuItem.id)"
            tabindex="0"
            class="block no-underline cursor-pointer"
          >
            <div class="card-modern shadow-hover p-4">
              <div class="flex align-items-center">
                <!-- Icon on the left -->
                <div
                  class="w-3rem h-3rem border-circle flex align-items-center justify-content-center shadow-soft flex-shrink-0"
                  style="background-color: var(--primary-color)"
                >
                  <i class="pi pi-calendar text-white text-xl"></i>
                </div>

                <!-- Text content vertically aligned to icon -->
                <div class="flex-grow-1 ml-3 flex align-content-center">
                  <h3 class="m-0 text-lg md:text-xl font-semibold">
                    {{ eventMenuItem.label }}
                  </h3>
                  <p class="m-0 text-sm text-color-secondary">
                    @if (eventMenuItem.date_begin) {
                      {{ eventMenuItem.date_begin | date: 'MMM d, y' }}
                    } @else {
                      Click to manage check-ins
                    }
                  </p>
                </div>

                <!-- Chevron on the right -->
                <i class="pi pi-angle-right text-2xl text-color-secondary ml-3"></i>
              </div>
            </div>
          </a>
        </div>
      }
    </div>
  </div>

  @if (!isLoading && eventMenuItemList.length === 0) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 text-center">
      <div class="card-modern p-5">
        <i class="pi pi-info-circle text-4xl text-color-secondary mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">No Events Found</h3>
        <p class="text-color-secondary">There are no active events for this company.</p>
      </div>
    </div>
  }

  @if (isLoading) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 text-center">
      <div class="card-modern p-5">
        <i class="pi pi-spin pi-spinner text-4xl text-color-secondary mb-3"></i>
        <h3 class="text-xl font-semibold mb-2">Loading Events...</h3>
      </div>
    </div>
  }
</div>
